<template>
  <div class="trade-detail">
    <div class="tab clearfix">
      <div
        class="tab-item"
        v-for="(item, index) in tabList"
        :key="index"
        :class="{'is-active': tabId==item.id}"
        @click="tabId=item.id"
      >
        <span>{{ item.name }}</span>
      </div>
    </div>
    <div class="content">
      <div v-for="(item, index) in tabList" :key="index" v-if="item.id==tabId">
        <List :tradeType="item.id"></List>
      </div>
    </div>
  </div>
</template>

<script>
import List from './list';
export default {
  components: {
    List
  },
  data () {
    return {
      tabId: 2,
      tabList: [{
        name: '可提现金额明细',
        id: 2
      }, {
        name: '冻结金额明细',
        id: 3
      }, {
        name: '积分明细',
        id: 1
      }]
    };
  }
};
</script>

<style lang="postcss" scoped>
.tab {
  margin-left: -40px;
  margin-right: -40px;
  border-bottom: 1px solid #E9EBED;
}

.tab-item {
  position: relative;
  float: left;
  padding-top: 30px;
  padding-bottom: 30px;
  margin-left: 40px;
  margin-right: 110px;
  font-size: 18px;
  color: #999;
  cursor: pointer;
  &.is-active {
    color: #333;
    &:before {
      content: " ";
      display: block;
      width: 40%;
      height: 3px;
      margin-left: 30%;
      position: absolute;
      left: 0;
      bottom: 0;
      background: #333333;
      border-radius: 2px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/account/wallet/tradeDetail.vue